import { EmployeeAddIconButton } from 'components/buttons/EmployeeAddIconButton';
import EmailListFormItem from 'components/forms/inputs/EmailListInput';
import { Control, Path } from 'react-hook-form';
import { EmailFields, InvoiceEmailFormBase } from 'types/invoices';

interface EmailFieldsSectionProps<T extends InvoiceEmailFormBase> {
    control: Control<T>;
    to: string[];
    cc: string[];
    bcc: string[];
    replyTo: string[];
    onRemoveEmail: (val: string, field: EmailFields) => void;
    onAddEmail: (val: string, field: EmailFields) => void;
    onOpenEmployeePicker: (field: EmailFields) => void;
}

export const EmailFieldsSection = <T extends InvoiceEmailFormBase>({
    control,
    to,
    cc,
    bcc,
    replyTo,
    onRemoveEmail,
    onAddEmail,
    onOpenEmployeePicker,
}: EmailFieldsSectionProps<T>) => {
    const fieldPath = (field: EmailFields) => field as Path<T>;

    return (
        <>
            <EmailListFormItem
                control={control}
                name={fieldPath('to')}
                onRemove={(val) => onRemoveEmail(val, 'to')}
                addEmail={(val) => onAddEmail(val, 'to')}
                label="invoices.email.to"
                watchedValue={to}
                autoComplete="off"
                rightLabelComponent={<EmployeeAddIconButton onClick={() => onOpenEmployeePicker('to')} />}
            />

            <EmailListFormItem
                control={control}
                name={fieldPath('replyTo')}
                onRemove={(val) => onRemoveEmail(val, 'replyTo')}
                addEmail={(val) => onAddEmail(val, 'replyTo')}
                label="invoices.email.reply-to"
                watchedValue={replyTo}
                required={false}
                autoComplete="off"
                rightLabelComponent={<EmployeeAddIconButton onClick={() => onOpenEmployeePicker('replyTo')} />}
            />

            <EmailListFormItem
                control={control}
                name={fieldPath('cc')}
                onRemove={(val) => onRemoveEmail(val, 'cc')}
                addEmail={(val) => onAddEmail(val, 'cc')}
                label="invoices.email.cc"
                watchedValue={cc}
                required={false}
                autoComplete="off"
                rightLabelComponent={<EmployeeAddIconButton onClick={() => onOpenEmployeePicker('cc')} />}
            />

            <EmailListFormItem
                control={control}
                name={fieldPath('bcc')}
                onRemove={(val) => onRemoveEmail(val, 'bcc')}
                addEmail={(val) => onAddEmail(val, 'bcc')}
                label="invoices.email.bcc"
                watchedValue={bcc}
                required={false}
                autoComplete="off"
                rightLabelComponent={<EmployeeAddIconButton onClick={() => onOpenEmployeePicker('bcc')} />}
            />
        </>
    );
};
